<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		control_bluetooth_device_ios,
		control_bluetooth_motion_blind_time_ios,
	} from 'src/services/native_container_requests_ios';
	import {
		control_bluetooth_device_android,
		control_bluetooth_motion_blind_time_android,
	} from 'src/services/native_container_requests_android';

	import { app, os } from 'src/stores/session/native-bridge';
	import { controlBleDevice } from 'src/stores/features/ble/control-device';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { valueOutOfRange } from 'src/helpers/utilities';

	import { Button, Text, Input, toast } from '@Shelly/shelly-design-system';
	import { BLU_STATUS } from 'src/types/requests/settings/blu_status';

	export let device;

	const min = 30;
	const max = 600;
	let motionBlindTime = device?.motionBlindTime || min;
	let initialized = false;

	const setMotionBlindTime = () => {
		if ($controlBleDevice.connectionState === 2) {
			$os === 'IOS'
				? control_bluetooth_motion_blind_time_ios(device.id, motionBlindTime)
				: control_bluetooth_motion_blind_time_android(device.id, motionBlindTime);

			bulkUpdate(device.id, { motionBlindTime });
		} else {
			$os === 'IOS'
				? control_bluetooth_device_ios(device.id, 'connect')
				: control_bluetooth_device_android(device.id, 'connect');
		}
	};

	$: switch ($controlBleDevice.currentStatusIndex) {
		// after receiving one of the statuses below remove the initialized state
		case BLU_STATUS.UNHANDLED_STATE:
		case BLU_STATUS.BUTTON_PRESS_REQUIRED:
		case BLU_STATUS.CONNECT_TO_DEVICE:
		case BLU_STATUS.DISCONNECT_FROM_DEVICE:
			initialized = false;
			break;
		// after receiving one of the statuses below add the initialized state
		case BLU_STATUS.DEVICE_OTA_AVAILABLE:
		case BLU_STATUS.DEVICE_OTA_REQUIRED:
		case BLU_STATUS.DEVICE_PROCESSED:
		case BLU_STATUS.BEACON_ENABLED:
		case BLU_STATUS.BEACON_DISABLED:
		case BLU_STATUS.MOTION_LED_ENABLED:
		case BLU_STATUS.MOTION_LED_DISABLED:
		case BLU_STATUS.BLIND_TIME_SET:
		case BLU_STATUS.SENSITIVITY_SET:
			initialized = true;
			break;
		default:
			break;
	}

	$: error = valueOutOfRange(motionBlindTime, min, max)
		? $format('error_out_of_range', {
				default: `Value ${motionBlindTime} is out of range. Please provide a value within the limits. (${min} — ${max})`,
				values: { value: motionBlindTime, max, min, unit: 'sec.' },
			})
		: '';
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_motion_ble_blind_time', {
		default: 'Blind time in seconds after last detected motion.',
	})}
</Text>

<Input
	aria-label={$format('input_motion_ble_blind_time', {
		default:
			'Enter the blind time in seconds after last detected motion. Value must be between {min} — {max}!',
		values: { min, max },
	})}
	icon="fas fa-eye-slash"
	class="mb-m"
	bind:value={motionBlindTime}
	type="number"
	step={1}
	{min}
	{max}
	info={$format('movement_limit_toast', {
		default: 'Values must be between {min} — {max}!',
		values: { min, max },
	})}
	{error}
	id="input-6r578gd"
/>

<Button disabled={!initialized || !$app || error} size="m" width="full" on:click={setMotionBlindTime}>
	{$format('button_save', { default: 'Save' })}
</Button>
